import { render } from "./ResetPassword.vue?vue&type=template&id=2338b372&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"

import "./ResetPassword.vue?vue&type=style&index=0&id=2338b372&lang=scss&scoped=true"
import "./ResetPassword.vue?vue&type=style&index=1&id=2338b372&lang=scss"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2338b372"]])

export default __exports__